<template>
  <b-form method="POST" @submit.prevent="() => false">
    <b-row>

      <!-- Image -->
      <b-col>
        <asset-block :field="{ label: 'Update image', type: 'IMAGE' }" v-model="form.image"/>
        <p>Your image will be resized &amp; cropped to 1000x1000 to support various social networks</p>
      </b-col>

    </b-row>
    <hr/>
    <b-row>
      <b-col>

        <!-- Title -->
        <b-form-group label="Title" label-for="title">
          <b-form-input id="title" type="text" placeholder="Enter the title of the piece of content" required v-model="form.title"
            :class="{ 'is-invalid': typeof formValid.title === 'string' }" />
          <div v-if="typeof formValid.title === 'string'" class="invalid-feedback">
            <template v-if="formValid.title === 'EMPTY'">Please enter a title</template>
            <template v-else-if="formValid.title === 'TOO_SHORT'">Please enter a longer title</template>
            <template v-else>{{ formValid.title }}</template>
          </div>
        </b-form-group>

        <!-- URL -->
        <b-form-group label="URL" label-for="url">
          <b-form-input id="url" type="url" placeholder="Enter the url of the piece of content" required v-model="form.url"
            :class="{ 'is-invalid': typeof formValid.url === 'string' }" />
          <div v-if="typeof formValid.url === 'string'" class="invalid-feedback">
            <template v-if="formValid.url === 'EMPTY'">Please enter a URL</template>
            <template v-else-if="formValid.url === 'INVALID'">Please enter a valid URL</template>
            <template v-else>{{ formValid.url }}</template>
          </div>
        </b-form-group>

        <!-- Description -->
        <b-form-group label="Description" label-for="description">
          <b-form-text class="p-0 mb-2">This description will be visible to employees and visitors</b-form-text>
          <b-form-textarea id="description" v-model="form.description" placeholder="Description ..." :rows="4" :max-rows="6" />
        </b-form-group>

      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" class="text-right">
        <b-form-group>
          <b-button v-if="buttons.includes('DELETE')" variant="danger" size="md" @click.prevent="$emit('deleteSelectedContentShare')">Delete</b-button>
          <b-button v-if="buttons.includes('ARCHIVE')" size="md" @click.prevent="$emit('disableSelectedContentShare')">Archive</b-button>
          <b-button v-if="buttons.includes('SAVE_DRAFT')" size="md" :disabled="!changed || !isFormValid" @click.prevent="submitInput('INACTIVE')">Save Draft</b-button>
          <b-button v-if="buttons.includes('PUBLISH')" variant="success" size="md" @click.prevent="$emit('publishSelectedContentShare')">Publish</b-button>
          <b-button v-if="buttons.includes('SAVE')" size="md" :disabled="!changed || !isFormValid" @click.prevent="submitInput()" variant="primary">Save</b-button>
          <b-button v-if="buttons.includes('PUBLISH_AND_SAVE')" size="md" :disabled="!changed || !isFormValid" @click.prevent="submitInput()" variant="success">Save & Publish</b-button>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import enumsMixin from '@/mixins/enums';
import formValidationMixin from '@src/mixins/formValidation';
import AssetBlock from '@/components/settings/AssetBlock';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AssetBlock,
  },
  mixins: [
    enumsMixin,
    formValidationMixin,
  ],
  data: () => ({
    form: {},
  }),
  created() {
    this.onResetForm();
  },
  formValidation: {
    title(value) {
      if (value && value.length <= 2) {
        return 'TOO_SHORT';
      } else if (value === '') {
        return 'EMPTY';
      } else {
        return true;
      }
    },
    url(value) {
      if (typeof value === 'string' && value === '') {
        return 'EMPTY';
      } else if (typeof value === 'string' && !value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)) {
        return 'INVALID';
      } else {
        return true;
      }
    },
  },
  computed: {
    changed() {
      let value = {};
      if (this.value) {
        const { title, url, description, image } = this.value;
        value = { title, url, description, image };
      }
      return JSON.stringify(value) !== JSON.stringify(this.form);
    },
    isFormValid() {
      const invalidInputs = Object.keys(this.formValid).filter(key => this.formValid[key] !== true);
      if (invalidInputs.length) return false;
      return true;
    },
    buttons() {
      const { value, changed } = this;
      if (!value || !value.id) {
        // return [ 'SAVE_DRAFT', 'PUBLISH_AND_SAVE' ];
        return [ 'PUBLISH_AND_SAVE' ];
      }
      if (value && value.status === 'ACTIVE') {
        return [ 'SAVE', 'ARCHIVE' ];
      }
      if (value && value.status === 'INACTIVE') {
        // return [ changed ? 'PUBLISH_AND_SAVE' : 'PUBLISH', 'SAVE_DRAFT', 'DELETE' ];
        return [ changed ? 'PUBLISH_AND_SAVE' : 'PUBLISH', 'DELETE' ];
      }
      return [];
    }
  },
  methods: {
    onResetForm() {
      if (this.value) {
        const { title, url, description, image } = this.value;
        this.form = {
          title: title || null,
          url: url || null,
          description: description || null,
          image: image || null,
        };
      }
    },
    submitInput(status) {
      if (!this.changed || !this.isFormValid) return;

      const input = JSON.parse(JSON.stringify(this.form));

      if (status) {
        input.status = status;
      } else {
        input.status = 'ACTIVE';
      }

      if (input.image && input.image.id) {
        input.image = { id: input.image.id };
      } else {
        delete input.image;
      }

      if (input.description === '') input.description = null;
      this.$emit('input', input);
    },
  },
  watch: {
    value() {
      this.onResetForm();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/ContentShareEditorForm.vue